<template>
    <modal dialog="modal-lg" class="dark-top" :footer="true">
        <div slot="title">
            <h2>Edit Business Type</h2>
        </div>
        <div slot="body">
            <div class="col-sm-12 py-3">
				<customBusinessTypeForm
					:customBusinessType="tempCustomBusinessType"
					@canSaveCustomBusinessType="canSaveCustomBusinessType = $event"
				></customBusinessTypeForm>
            </div>
        </div>

        <div slot="footer" class="d-flex align-items-center justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="close">Cancel</button>
            <button type="button" class="btn wider mr-3" @click="save">Save</button>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal'
    import customBusinessTypeForm from './customBusinessTypeForm'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data: function() {
            return {
                tempCustomBusinessType: null,
				canSaveCustomBusinessType: false,
            }
        },
        created: function() {
            this.tempCustomBusinessType = JSON.parse(JSON.stringify(this.getSelectedCustomBusinessType))
        },
        computed: {
            ...mapGetters([
                'getSelectedCustomBusinessType',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'setSelectedCustomBusinessType',
                'deleteCustomBusinessType',
                'updateCustomBusinessType',
                'fetchCustomBusinessTypes'
            ]),
            deleteChannel: function(customBusinessType) {
                this.deleteCustomBusinessType(customBusinessType)
            },
            save: function() {

				const isChange = JSON.stringify(this.tempCustomBusinessType) !== JSON.stringify(this.getSelectedCustomBusinessType)

				// if no change, just close the modal
				if(!this.canSaveCustomBusinessType && !isChange) return this.close()

				if(!this.canSaveCustomBusinessType) {
					this.$toasted.error('Please fill in all required fields');
					return
				}

                this.updateCustomBusinessType(this.tempCustomBusinessType).then(success => {
                    if(success == true){
                        this.closeModal();
                        this.fetchCustomBusinessTypes();
                    }
                })
            },
            close: function() {
                this.setSelectedCustomBusinessType(null)
                this.closeModal();
            },
        },
        components: {
            Modal,
			customBusinessTypeForm
        }
    }
</script>

<style lang="scss" scoped>
    .langPicker{
        width: 250px;
    }
</style>



// WEBPACK FOOTER //
// editCustomBusinessType.vue?554c1505